// In a new file or inline
import { useFeatureFlagVariantKey } from "posthog-js/react";
import { lazy, Suspense, useEffect, useState } from "react";
import { LoaderScreen } from "../../../components/LoaderScreen/LoaderScreen";

const FLAG_TIMEOUT_MS = 3000;

const NewHome = lazy(() =>
  import("../NewHome/NewHome").then((m) => ({
    default: m.NewHome,
  })),
);
const NewHome2 = lazy(() =>
  import("../NewHome/NewHome2").then((m) => ({
    default: m.NewHome,
  })),
);

export const Home = () => {
  const key = useFeatureFlagVariantKey("show-new-marketing-home");
  const [timedOut, setTimedOut] = useState(false);

  // `key` is `undefined` only while the flag is still loading; a disabled flag
  // resolves to `false`. Only the loading state should wait on the timeout — a
  // resolved (even disabled) flag must render immediately rather than stall on
  // a blank loader, which otherwise hit every ad-blocked visitor for 3s.
  useEffect(() => {
    if (key !== undefined) return;
    const id = setTimeout(() => setTimedOut(true), FLAG_TIMEOUT_MS);
    return () => clearTimeout(id);
  }, [key]);

  const variant =
    key === undefined
      ? timedOut
        ? "control"
        : null
      : typeof key === "string"
        ? key
        : "control";

  if (!variant) {
    return <LoaderScreen />;
  }

  return (
    <Suspense fallback={<LoaderScreen />}>
      {variant === "control" ? <NewHome /> : <NewHome2 />}
    </Suspense>
  );
};
